import React from "react";
import Link from "gatsby-link";
import { Box, Flex } from "rebass";
import Text from "./Text";
import styled from "styled-components";

const Wrapper = styled(Box)`
  display: block;
  cursor: pointer;
  text-decoration: none;
`;

Wrapper.defaultProps = {
  is: Link,
  to: "/",
};

const Container = styled(Flex)`
  align-items: center;
`;

const Avatar = styled(Box)`
  width: 96px;
  min-width: 96px;
  height: 96px;
  min-height: 96px;
  border-radius: 9999px;
  border: 1px solid ${(props) => props.theme.colors.grey[1]};
  background: ${(props) => props.theme.colors.grey[1]};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: ${(props) => "url(" + props.image + ")"};
`;

Avatar.defaultProps = {
  mr: 3,
};

const Authorship = styled(Text)`
  font-size: ${(props) => props.theme.fontSizes[2]};
  font-weight: 400;
  color: ${(props) => props.theme.colors.grey[0]};
  line-height: 1.25;

  &::selection {
    color: ${(props) => props.theme.colors.grey[2]};
    background-color: ${(props) => props.theme.colors.violet};
  }
`;

const Name = styled(Text)`
  font-size: ${(props) => props.theme.fontSizes[2]};
  font-weight: 600;
  color: ${(props) => props.theme.colors.grey[0]};
  line-height: 1.5;

  &::selection {
    color: ${(props) => props.theme.colors.grey[2]};
    background-color: ${(props) => props.theme.colors.violet};
  }
`;

const StaffProfile = (props) => (
  <Wrapper to={"/" + props.to} is={Link}>
    <Container>
      <Avatar image={props.image} />
      <Box>
        <Authorship
          children={
            props.attributionText ? props.attributionText : "Written by"
          }
        />
        <Name children={props.name} />
      </Box>
    </Container>
  </Wrapper>
);

StaffProfile.defaultProps = {
  image: "https://sidewalklabs.com/assets/uploads/2018/04/bowden-copy.jpg",
  name: "John Doe",
};

export default StaffProfile;



// WEBPACK FOOTER //
// ./src/components/StaffProfile.js